<template>
  <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
    item-key="name"
    :loading="loading"
    :loading-text="$t('loading_text')"
    :headers="translatedHeaders"
    :items="reservations"
    :search="search"
    :footer-props="footerProps"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('search')"
        class="mx-4"
      ></v-text-field>
    </template>

    <template v-slot:item.planned_trip.route.name="{ item }">
      <a @click.stop="displayRoute(item.planned_trip.route.id)">{{
        item.planned_trip.route.name
      }}</a>
    </template>

    <template v-slot:item.customer.name="{ item }">
      <div>
        <a v-if="item.customer" class="font-weight-bold primary--text text-decoration-none cursor-pointer" @click.stop="openCustomerProfile(item.customer)">
          {{ item.customer.name }}
        </a>
        <span v-else class="grey--text">—</span>
        <div class="text-caption font-weight-regular grey--text text--darken-2" dir="ltr" style="text-align: right;">
          {{ (item.customer && (item.customer.phone_number || item.customer.tel_number)) ? (item.customer.phone_number || item.customer.tel_number) : '—' }}
        </div>
      </div>
    </template>

    <template v-slot:item.planned_trip.driver.name="{ item }">
      <div>
        <a v-if="item.planned_trip && item.planned_trip.driver" class="font-weight-bold primary--text text-decoration-none cursor-pointer" @click.stop="displayDriver(item.planned_trip.driver.id)">
          {{ item.planned_trip.driver.name }}
        </a>
        <span v-else class="grey--text">—</span>
        <div class="text-caption font-weight-regular grey--text text--darken-2" dir="ltr" style="text-align: right;">
          {{ (item.planned_trip && item.planned_trip.driver && (item.planned_trip.driver.phone_number || item.planned_trip.driver.tel_number)) ? (item.planned_trip.driver.phone_number || item.planned_trip.driver.tel_number) : '—' }}
        </div>
      </div>
    </template>

    <template v-slot:item.first_stop.name="{ item }">
      <a @click.stop="displayStop(item.first_stop.id)">{{
        item.first_stop.name
      }}</a>
    </template>

    <template v-slot:item.last_stop.name="{ item }">
      <a @click.stop="displayStop(item.last_stop.id)">{{
        item.last_stop.name
      }}</a>
    </template>

    <template v-slot:item.paid_price="{ item }">
      <div>
        <div class="font-weight-medium">{{ Math.round(item.paid_price * 100) / 100 }} ج.م</div>
        <v-chip
          x-small
          :color="item.payment_method === 1 ? 'amber lighten-4' : 'blue lighten-5'"
          :class="item.payment_method === 1 ? 'amber--text text--darken-4' : 'blue--text text--darken-3'"
          class="font-weight-bold"
        >
          {{ item.payment_method === 1 ? (item.cash_collected_at ? 'نقدي (تم التحصيل)' : 'نقدي (مطلوب)') : 'إلكتروني' }}
        </v-chip>
      </div>
    </template>

    <template v-slot:item.boarding_status="{ item }">
      <v-chip
        x-small
        :color="item.boarding_status === 'boarded' ? 'success' : (item.boarding_status === 'no_show' ? 'error' : 'warning')"
        class="font-weight-bold"
      >
        {{ item.boarding_status === 'boarded' ? 'صعد' : (item.boarding_status === 'no_show' ? 'لم يصعد' : 'منتظر') }}
      </v-chip>
    </template>

    <template v-slot:item.planned_trip.planned_date="{ item }">
      <small>{{ item.planned_trip.planned_date | moment("LL") }}</small> -
      <small class="text-muted">{{ item.planned_start_time}}</small>
    </template>

    <template v-slot:item.created_at="{ item }">
      <small>{{ item.created_at | moment("LL") }}</small>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn depressed small density="compact"
      color="error"
      :icon="true"
      @click="cancelReservation(item, reservations.indexOf(item))">
        <v-icon dark> mdi-bank-minus </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>

export default {
  props: {
    reservations: Array,
    showCancel: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      search: "",
      headers: [
        { text: "id", value: "id", align: "start", filterable: false },
        { text: "ticket", value: "ticket_number"},
        { text: "Customer", value: "customer.name" },
        { text: "Driver", value: "planned_trip.driver.name" },
        { text: "route", value: "planned_trip.route.name"},
        { text: "from", value: "first_stop.name" },
        { text: "to", value: "last_stop.name" },
        { text: "boarding_status", value: "boarding_status" },
        { text: "time_of_trip", value: "planned_trip.planned_date" },
        { text: "paid_price", value: "paid_price"},
        { text: "reserved_on", value: "created_at" },
      ],
    };
  },
  mounted() {
    let finalHeaders = this.headers;
    if (this.showCancel) {
      finalHeaders = this.headers.concat({
        text: "cancel",
        value: "actions",
        sortable: false,
      });
    }
    this.headers = finalHeaders;
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    }
  },
  methods: {
    displayRoute(route_id) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route_id },
      });
    },
    displayCustomer(customer_id) {
      this.$router.push({
        name: "view-user",
        params: { user_id: customer_id, },
      });
    },
    openCustomerProfile(customer) {
      if (customer && customer.id) {
        this.$emit("open-customer-profile", customer);
      }
    },
    displayDriver(driver_id) {
      this.$router.push({
        name: "view-user",
        params: { user_id: driver_id, },
      });
    },
    displayStop(stop_id)
    {
      this.$router.push({
        name: "view-stop",
        params: { stop_id: stop_id, },
      });
    },
    cancelReservation(reservation, index) {
      this.$emit("cancel-reservation", reservation, index);
    },
  },
};
</script>
